import React from 'react'

const Loading = () => {
  return (
    <div className='flex w-100 h-100 items-center justify-center pt7'>
      <div>Loading GraphQL endpoint...</div>
    </div>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js